import{joinUrl}from"@jutro/platform";export function locationToString(location){return`${joinUrl(location.pathname,location.search)}${location.hash}`}